import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateFormatLocale',
    standalone: false
})
export class TranslateFormatLocaleMockPipe implements PipeTransform {
    transform(key: string, languageCode: string, ...params: any[]): string {
        return key;
    }
}
